import request from '../utils/request';

// Get fans list
export function getFansList(params) {
    return request({
        url: '/link_fans/get_list',
        method: 'get',
        params
    });
}

// TODO  后续再处理吧 手动回传 conversion
export function ttCallbackConversion(data) {
    return request({
        url: '/tt_callback/conversion',
        method: 'post',
        data
    });
}
